var currentWindow = null;

function createMapImg(data) {
  var html = '\
    <img title="' + data[0] + '" alt="' + data[0] + '" src="http://maps.googleapis.com/maps/api/staticmap?center=' + data[2] + ',' + data[3] + '&zoom=17&size=' + data[5] + 'x' + data[6] + '&scale=1&markers=color:black%7Clabel%3%7C' + data[2] + ',' + data[3] + '&sensor=false" class="' + data[4] + 'mapImg mapImg">\
    ';

  $('#' + data[4] + '').append(html);
  $('.' + data[4] + 'mapImg').on('click', function () {
    $(this).remove();
    createMap(data);
  });
}

function createAnyPinMap(data) {

  if ('map_setting' in data) {
    var map_height;

    if (_getDevice == "mobile") {
      map_height = 350;
    } else {
      if (data.map_setting.height) {
        map_height = data.map_setting.height;
      } else {
        map_height = 300;
      }
    }

    $("#" + data.map_setting.id).css('height', map_height);

    var myLatlng = new google.maps.LatLng(data.map_setting.center_lat, data.map_setting.center_lng);

    var map_zoom;
    if (data.map_setting.zoom) {
      map_zoom = data.map_setting.zoom;
    } else {
      map_zoom = 16;
    }

    if (_getDevice == "mobile") {
      map_zoom = 13;
    }

    if (_getDevice == "mobile") {
      var mapOptions = {
        zoom: map_zoom,
        center: myLatlng,
        mapTypeControl: false,
        panControl: false,
        streetViewControl: false,
        disableDoubleClickZoom: false,
        scrollwheel: false,
        // draggable: false,
        styles: [{
          stylers: [{
            saturation: -100
          }]
        }] //彩度
      };
    } else {
      var mapOptions = {
        zoom: map_zoom,
        center: myLatlng,
        mapTypeControl: false,
        panControl: false,
        streetViewControl: false,
        disableDoubleClickZoom: false,
        scrollwheel: false,
        styles: [{
          stylers: [{
            saturation: -100
          }]
        }] //彩度
      };
    }


    var map = new google.maps.Map(document.getElementById(data.map_setting.id), mapOptions);

    var name;
    var latlng;
    var icons;

    var objKeys = Object.keys(data.map_data);

    for (var i = 0, len = objKeys.length; i < len; i++) {
      var obj_tgt = data.map_data[i];
      setTimeout(function (obj_tgt) {
        name = '<strong>' + obj_tgt.title + '</strong>';
        latlng = new google.maps.LatLng(obj_tgt.lat, obj_tgt.lng);

        if (obj_tgt.pin) {
          icons = {
            url: obj_tgt.pin,
            scaledSize: new google.maps.Size(42, 53),
          };
        }

        createMarker(name, latlng, icons, map);
      }, 200 * i, obj_tgt);
    }

  } else {
    return null;
  }

}



function createMarker(name, latlng, icons, map) {
  var infoWindow = new google.maps.InfoWindow();

  var marker = new google.maps.Marker({
    position: latlng,
    icon: icons,
    map: map,
    animation: google.maps.Animation.DROP
  });


  // google.maps.event.addListener(marker, 'mouseover', function() {
  //     if (currentWindow) {
  //         currentWindow.close();
  //     }
  //     infoWindow.setContent(name);
  //     infoWindow.open(map,marker);
  //     currentWindow = infoWindow;
  // });

  //クリック動作
  // google.maps.event.addListener(marker, 'click', function() {
  //     if (currentWindow) {
  //         currentWindow.close();
  //     }
  //     // map.setZoom(14);
  //     map.setCenter( latlng ) ;
  //     infoWindow.setContent(name);
  //     infoWindow.open(map,marker);
  //     currentWindow = infoWindow;
  // });
}